export const sharedWorker = {};

export const sharedWorkerMessageType = {
    registerWindow: 'REGISTER_NEW_WINDOW',
    windowIdUpdate: 'WINDOW_ID_UPDATE',
    removeWindow: 'REMOVE_WINDOW',
    releaseOrphanedEndpoints: 'RELEASE_ORPHANED_ENDPOINTS',
    forceReload: 'FORCE_RELOAD',
    windowsCountChange: 'WINDOWS_COUNT_CHANGE',
    windowModeChange: 'WINDOW_MODE_CHANGE',
    deskPauseRequestSent: 'DESK_PAUSE_REQUEST_SENT',
    deskSelected: 'DESK_SELECTED',
    transactionFinished: 'TRANSACTION_FINISHED',
    transactionReopen: 'TRANSACTION_REOPEN',
    subscribe: 'SUBSCRIBE_TO_STOMP_BROKER_TOPIC',
    unsubscribe: 'UNSUBSCRIBE_FROM_STOMP_BROKER_TOPIC',
    stompMessage: 'STOMP_BROKER_MESSAGE',
    machineWakeUpDetected: 'MACHINE_WAKE_UP_DETECTED',
    stompBrokerConnectionStateChange: 'stompBrokerConnectionStateChange',
    stickyLanePinToggle: 'STICKY_LANE_PIN_TOGGLE',
    stickyLanesSeed: 'STICKY_LANES_SEED',
    pinnedLanesChange: 'PINNED_LANES_CHANGE',
    streamingCameraCountChange: 'STREAMING_CAMERA_COUNT_CHANGE',
    streamingCameraTotalChange: 'STREAMING_CAMERA_TOTAL_CHANGE',
    videoWallConfigChange: 'VIDEO_WALL_CONFIG_CHANGE',
    videoWallsChange: 'VIDEO_WALLS_CHANGE',
    applyVideoWallConfig: 'APPLY_VIDEO_WALL_CONFIG',
    queueVideoWallConfig: 'QUEUE_VIDEO_WALL_CONFIG',
    heartbeatPing: 'HEARTBEAT_PING',
    heartbeatPong: 'HEARTBEAT_PONG',
};

export const stompTopics = {
    transactionDesk: 'transactionDesk',
    videoWall: 'videoWall',
    streamTest: 'streamTest',
    vinCheck: 'vinCheck',
    vinCheckLocation: 'vinCheckLocation',
    allDesks: 'allDesks',
    cameraUpdates: { topicName: 'cameraUpdates', topicUrl: '/topic/camera-updates' },
    kurentoStatus: { topicName: 'kurentoStatus', topicUrl: '/topic/kurento-status' },
};
export const cameraStreamRelatedTopics = [
    stompTopics.transactionDesk,
    stompTopics.videoWall,
    stompTopics.streamTest,
    stompTopics.vinCheck,
    stompTopics.allDesks,
];

let messageHandler = {
    get: function (target, name) {
        if (Object.hasOwn(target, name)) {
            return (data) => ({
                type: sharedWorkerMessageType[name],
                ...(sharedWorker.id && { id: sharedWorker.id }),
                data,
            });
        } else return () => {};
    },
};

let actionHandler = {
    get: function (target, name) {
        if (Object.hasOwn(target, name)) {
            return (data) =>
                sharedWorker.port &&
                sharedWorker.port.postMessage({
                    type: sharedWorkerMessageType[name],
                    id: sharedWorker.id,
                    data,
                });
        } else return () => {};
    },
};

export const sharedWorkerMessage = new Proxy(sharedWorkerMessageType, messageHandler);
export const sharedWorkerActions = new Proxy(sharedWorkerMessageType, actionHandler);
